import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { FormSelect, FormCurrencyField } from '../../../../lib/components';
import { CompanyFormProps, CompanyForm } from '../shared/companyForm';
import { FeedbackAlert } from '../../../../lib/components/atomic/feedback';
import { PaginatedBenefitSetList } from '@pxtra-client-lib-legacy/gen';

type Props = Omit<CompanyFormProps, 'children'> & {
  benefitSets?: PaginatedBenefitSetList;
};

export const CompanyDefaultValuesForm: FC<Props> = ({ benefitSets, ...props }) => {
  const { t } = useTranslation();

  return (
    <CompanyForm {...props}>
      <Grid item xs={12}>
        <FeedbackAlert severity="info" description={t('company:DEFAULT_ASSIGNMENT_HINT')} />
      </Grid>
      <FormCurrencyField
        label={t('company:DEFAULT_BUDGET')}
        xs={6}
        placeholder={t('company:DEFAULT_BUDGET_PLACEHOLDER')}
        name="defaultBenefitBudget"
        shiftDecimals={2}
        returnInteger
      />
      <FormSelect
        label={t('company:DEFAULT_BENEFIT_SET')}
        xs={6}
        placeholder={t('company:DEFAULT_BENEFIT_SET_PLACEHOLDER')}
        name="defaultBenefitSet"
        options={[
          { value: '', text: '-' },
          ...(benefitSets?.results.map((bs) => ({
            value: bs.id ?? '',
            text: bs.name ?? ''
          })) ?? [])
        ]}
      />
    </CompanyForm>
  );
};
